/** Shared Appendix 1 award-standard strand classification. */

export type AppendixStrandId =
  | "knowledge_breadth"
  | "knowhow_skill"
  | "competence_context"
  | "competence_role"
  | "competence_learning"
  | "competence_insight";

export const APPENDIX_STRANDS: readonly { id: AppendixStrandId; label: string }[] = [
  { id: "knowledge_breadth", label: "Knowledge: breadth and kind" },
  { id: "knowhow_skill", label: "Know-how and skill: range and selectivity" },
  { id: "competence_context", label: "Competence: context" },
  { id: "competence_role", label: "Competence: role" },
  { id: "competence_learning", label: "Competence: learning-to-learn" },
  { id: "competence_insight", label: "Competence: insight" },
];

function normaliseStandardLocation(value: string): string {
  return value.toLowerCase().replaceAll("-", " ").replaceAll("&", "and").replace(/\s+/g, " ");
}

/** Resolve a criteria/thread pair to one of the six QQI Appendix 1 strands. */
export function resolveAppendixStrand(criteria: string, thread: string): AppendixStrandId | null {
  const location = normaliseStandardLocation(`${criteria} ${thread}`);
  if (location.includes("learning to learn")) {
    return "competence_learning";
  }
  if (location.includes("context")) {
    return "competence_context";
  }
  if (location.includes("role")) {
    return "competence_role";
  }
  if (location.includes("insight")) {
    return "competence_insight";
  }
  if (
    location.includes("know how") ||
    location.includes("skill") ||
    location.includes("range") ||
    location.includes("selectivity")
  ) {
    return "knowhow_skill";
  }
  if (location.includes("knowledge") || location.includes("breadth") || location.includes("kind")) {
    return "knowledge_breadth";
  }
  return null;
}
